import React, { useMemo } from "react";
import ChapterNode from "./components/ChapterNode";
import { CourseChaptersInfo } from "API/courseware";
import styles from "./index.module.scss";
import ChaptersListFooter from "./components/ChaptersListFooter";
import { percent2Number } from "Utils/filter";
import CoursewareItem from "./components/CoursewareItem";

interface ChaptersListProps {
    data: CourseChaptersInfo;
}

export default function ChaptersListMobile({ data }: ChaptersListProps) {
    const percent = useMemo(
        () => percent2Number(data.learnProgress),
        [data.learnProgress]
    );

    return (
        <div className={styles.root}>
            {data.sourceChapter.children?.map(item => (
                <ChapterNode
                    key={item.id}
                    title={item.chapterName}
                    chapters={item.children || []}
                    sources={item.dcCoursewareSourceList || []}
                />
            ))}

            {data.sourceChapter.dcCoursewareSourceList?.map(item => (
                <CoursewareItem key={item.id} data={item} indent={0} />
            ))}

            <ChaptersListFooter percent={percent} />
        </div>
    );
}
